import {
  REQUEST_GEO_QUERY,
  RECEIVE_GEO_QUERY,
  GEO_FAILED,
  REQUEST_GEO_TYPE_QUERY,
  RECEIVE_GEO_TYPE_QUERY
} from '../actions/types';

export const geotargetRequest = (state = {}, action) => {
  switch(action.type) {
    case RECEIVE_GEO_QUERY:
      return Object.assign({}, state, {
        isFetching: false,
        cache: Object.assign({}, state.cache, { [action.query]: action.payload })
      });
    case REQUEST_GEO_QUERY:
      return Object.assign({}, state, {
        isFetching: true,
        cache: state.cache || {}
      });
    case GEO_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        cache: state.cache || {}
      });
    default: {
      return state;
    }
  }
}

function geoRequest(state = {}, action) {
  switch(action.type) {
    case RECEIVE_GEO_TYPE_QUERY:
      return Object.assign({}, state, {
        isFetching: false,
        geos: action.geos
      });
    case REQUEST_GEO_TYPE_QUERY:
      return Object.assign({}, state, {
        isFetching: true,
        geos: []
      });
    case GEO_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        geos: null,
        error: action.error
      });
    default: {
      return state;
    }
  }
}

export default geoRequest;
